import React, { useState, useEffect } from 'react'

import axios from 'axios'
import CardColumns from 'react-bootstrap/CardColumns'

import { REST_API } from './../../services/constants'
import authHeader from './../../services/auth-header'
import UploadedFile from '../../components/uploads/UploadedFile'

export default function TaskFileList(props) {

    const [ files, setFiles ] = useState([]);

    const updateFiles = async () => {
        axios({
            url: `${REST_API}/api/secure/cloud/files/uploaded_files/`,
            headers: await authHeader(),
            params: {
                taskId: props.taskId
            }
        }).then(response => {
            if (response.status === 200) {
                setFiles(response.data);
            }
        });
    }

    useEffect(() => {
        updateFiles();
    }, [props.taskId]);

    return (
        <>
            {
                files.length > 0 ?
                <>
                    <h3 className="mt-4 mb-3">Anhang</h3>
                    <CardColumns className="task-attachments">
                        {
                            files.map((file, index) => {
                                return (
                                    <UploadedFile key={index} data={file} />
                                )
                            })
                        }
                    </CardColumns>
                </>
                : null
            }
        </>
    )
}
